import { defineStyle, defineStyleConfig } from "@chakra-ui/react";
import { colors } from "../../../../theme/foundations/generated";
const baseStyle = defineStyle({
    borderWidth: 4,
    color: "semantic.brand.secondary",
});
const withBackgroundTrackColor = "semantic.border.secondary";
const withoutBackgroundTrackColor = `${colors.semantic.icon.inverse}4D`;
const variants = {
    default: defineStyle({
        borderBottomColor: withoutBackgroundTrackColor,
        borderLeftColor: withoutBackgroundTrackColor,
        borderTopColor: withoutBackgroundTrackColor,
    }),
    withBackground: defineStyle({
        borderBottomColor: withBackgroundTrackColor,
        borderLeftColor: withBackgroundTrackColor,
        borderTopColor: withBackgroundTrackColor,
    }),
};
const spinnerTheme = defineStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: "default",
    },
});
export default spinnerTheme;
//# sourceMappingURL=Spinner.default.js.map